var UIFileUploader = (function ($) {

    UIFileUploader = function () {
        var that = this;

        // SELECTORS
        that.select_file_uploader = '.file-uploader'
        that.select_file_form = '.file-form'
        that.select_file_elem = '.file-elem'
        that.select_gallery = '.gallery'
        that.select_gallery_file_template = '.gallery-file.js-template'
        that.select_gallery_file = '.gallery-file:not(.js-template)'
        that.select_remove_button = '.js-remove-file'
        
        that.class = {
            error: 'error'
        };

        // Храним ссылки на последние файлы, для поддержки удаления и добавления
        // Определяем ключ по уникальному id из <input />
        that.cached_files = {}

        // INIT
        that.init();
    };

    UIFileUploader.prototype.init = function () {
        var that = this;

        //
        that.initEventHandlers();
    };

    UIFileUploader.prototype.__preventDefaults = function (e) {
        e.preventDefault()
        e.stopPropagation()
    }

    UIFileUploader.prototype.initEventHandlers = function () {
        var that = this;

        ;['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
            $.sa.$document.on(eventName, that.select_file_uploader, function (e) {
                that.__preventDefaults(e)
            });
        })

        ;['dragenter', 'dragover'].forEach(eventName => {
            $.sa.$document.on(eventName, that.select_file_uploader, function (e) {
                var $file_uploader = $(e.target).closest(that.select_file_uploader)

                $file_uploader.addClass('highlight')
            });
        })

        ;['dragleave', 'drop'].forEach(eventName => {
            $.sa.$document.on(eventName, that.select_file_uploader, function (e) {
                var $file_uploader = $(e.target).closest(that.select_file_uploader)

                $file_uploader.removeClass('highlight')

                // Добавление файла посредством перетаскивания
                if (eventName === 'drop') {
                    var $input_file = $file_uploader.find(that.select_file_elem)
                    that.appendFiles($input_file, e.originalEvent?.dataTransfer?.files)
                }
            });
        })

        // Добавление файла через кнопку
        $.sa.$document.on('change', that.select_file_elem, function (e) {
            var $input_file = $(e.target)

            if ($input_file.hasClass(that.select_file_elem.substring(1))) {
                that.appendFiles($input_file, e.target?.files)
            }
        });

        // Удаление файла по клику на крестик
        $.sa.$document.on('click', that.select_remove_button, function (e) {
            var $remove_button = $(e.target)
            var $gallery_file = $remove_button.closest('.gallery-file')

            if ($gallery_file.hasClass('gallery-file')) {
                var $file_uploader = $gallery_file.closest(that.select_file_uploader)
                var $input_file = $file_uploader.find(that.select_file_elem)

                var file_name = $gallery_file.find('.file-title').text()

                that.removeFile($input_file, file_name)
            }
        });

    };

    /**
     * Объединяем два массива файлов, избегая дубликатов
     */
    UIFileUploader.prototype.mergeFiles = function (files1, files2) {
        const result_files = [...files1];

        [...files2].forEach(file => {
            if (!result_files.find(res_file => res_file.name === file.name)) {
                result_files.push(file)
            }
        });

        return result_files;
    }

    /**
     * @params {File[]} files Array of files to add to the FileList
     * @return {FileList}
     */
    UIFileUploader.prototype.FileListItems = function (files) {
        var b = new ClipboardEvent("").clipboardData || new DataTransfer()
        for (var i = 0, len = files.length; i<len; i++) b.items.add(files[i])
        return b.files
    }

    UIFileUploader.prototype.appendFiles = function ($input_file, files) {
        var that = this;
        var id = $input_file.attr('id')

        var prev_files = that.cached_files[id] || []

        var result_files = that.mergeFiles(prev_files, files)
        $input_file.prop('files', that.FileListItems(result_files))

        that.cached_files[id] = result_files

        that.previewFiles($input_file, result_files)
    }

    UIFileUploader.prototype.removeFile = function ($input_file, file_name) {
        var that = this;
        var id = $input_file.attr('id')

        var prev_files = that.cached_files[id] || []

        var result_files = prev_files.filter(pr_file => pr_file.name !== file_name)
        $input_file.prop('files', that.FileListItems(result_files))

        that.cached_files[id] = result_files

        that.previewFiles($input_file, result_files)
    }

    /**
     * Добавление файлов под file-uploader
     * @param {*} $gallery место для отображения файлов в выбранном file-uploader
     * @param {*} files
     */
    UIFileUploader.prototype.previewFiles = function ($input_file, files) {
        var that = this;
        var $file_uploader = $input_file.closest(that.select_file_uploader)
        var $gallery = $file_uploader.find(that.select_gallery)
        var $gallery_file_template = $gallery.find(that.select_gallery_file_template)

        $gallery.find(that.select_gallery_file).remove()

        that.__clearError($file_uploader);

        if (files.length < 1) {
            $gallery.hide()
            return
        }

        $gallery.show()
        
        files.forEach(function(file) {
          let $gallery_file = $gallery_file_template.clone().removeClass('js-template')

          $gallery_file.find('.file-title').text(file.name)

          $gallery.append($gallery_file)
        })
    }

    UIFileUploader.prototype.__clearError = function ($input_file) {
        var that = this,
            $file_uploader = $input_file.closest(that.select_file_uploader),
            $error = $file_uploader.find('.error');
        
        $file_uploader.removeClass(that.class.error)

        $error.text('');
    };

    return UIFileUploader;
})($);
